import { extent } from "d3-array"
import memoize from "memoize-one"
import deepEqual from "deep-equal"

import { arrayWithContents } from "../../../utils"
import { id_accessor } from "../../../../components/shared_components_registration"

export const getActionExtent = (run, timeExtractor) => {
  const action_extent = extent(run.actions || [], timeExtractor.getActionTime)
  const site_action_extent = extent(run.site_actions || [], timeExtractor.getActionTime)
  const annotations = extent(run.annotations || [], timeExtractor.getActionTime)

  return extent([...action_extent, ...site_action_extent, ...annotations])
}

export const getObservations = (observationAccessor, obsList) => {
  if (!observationAccessor) return []

  return obsList.map((series) => observationAccessor(series.tag, series.units, series.smp_src))
}

// Class for shared functionalities between ObservationPlotFactory and MultiRunPlotFactory
export class AbstractObservationPlotBaton {
  getDataRange(accessor, seriesData) {
    const observationExtents = []
    for (const obs of seriesData) {
      if (obs && arrayWithContents(obs.data)) {
        const [min, max] = extent(obs.data, accessor)
        observationExtents.push(min, max)
      }
    }
    return extent(observationExtents)
  }

  getTimeRange(run_id, timeExtractor, ...seriesData) {
    const accessor = timeExtractor.getObservationTime
    return this.getDataRange(accessor, seriesData)
  }

  dataRangeForObs(run_id, ...seriesData) {
    const accessor = (obs) => obs.value
    return this.getDataRange(accessor, seriesData)
  }

  getAxis1Range = memoize(this.dataRangeForObs, deepEqual)
  getAxis2Range = memoize(this.dataRangeForObs, deepEqual)
  timeRangeForObs = memoize(this.getTimeRange, deepEqual)

  getTimeAxes(run, viewerState, timeExtractor) {
    const obvTimeRange = this.timeRangeForObs(
      run[id_accessor],
      timeExtractor,
      ...getObservations(run.observationAccessor, this.config[this.dataKey]),
    )
    const action_extent = getActionExtent(run, timeExtractor)

    return extent([...obvTimeRange, ...action_extent])
  }

  getAxesAndRanges(run, viewerState, timeExtractor) {
    this.y1obs = (this.config[this.dataKey] || []).filter((obs) => !obs.axis2 && !obs.disabled)
    this.y2obs = (this.config[this.dataKey] || []).filter((obs) => obs.axis2 && !obs.disabled)

    const axes = {}

    axes.time = this.getTimeAxes(run, viewerState, timeExtractor)

    if (this.y1obs.length > 0) {
      axes.y = this.getAxis1Range(run[id_accessor], ...getObservations(run.observationAccessor, this.y1obs))
    }
    if (this.y2obs.length > 0) {
      axes.y2 = this.getAxis2Range(run[id_accessor], ...getObservations(run.observationAccessor, this.y2obs))
    }

    return axes
  }
}
